import {Injectable} from '@angular/core';
import {BdbRequestService} from '../../shared/bdb-request.service';
import {SecurePassword} from '../model/secure-password';
import {environment} from '../../../../environments/environment';
import {RequestInfo} from '../../models/request-info.model';
import {BdbEncryptService, BdbSessionStrgService} from '@npm-bbta/bbog-cm-auth-lib';
import {ResponseFromFetch} from '../../models/response-from-fetch.model';
import {BdbDeviceIdService} from '../../shared/bdb-device-id.service'
import {SandboxRequestService} from '../../shared/sandbox/sandbox-request.service';
import {SessionStorageKeysEnum} from '../../models/session-storage-keys-enum';
import {IBodyForSecureKey} from '../../shared/models/IBodyForSecureKey';
import {EventsService} from '../../shared/bdb-event.service';

@Injectable()
export class SecurePasswordService {

  constructor(private readonly bdbSessionStorageService: BdbSessionStrgService,
               private bdbRequestService: BdbRequestService,
               private bdbEncryptService: BdbEncryptService,
               private bdbDeviceIdService: BdbDeviceIdService,
               private bdbEventsService: EventsService,
               private sandbox: SandboxRequestService
  ) { }

  private readonly securePasswordEndpoint = '/authentication/universalkey/v4';

  validateSecurePassword(securePassword: SecurePassword): Promise<ResponseFromFetch> {
      const encryptedDocumentNumber = this.bdbEncryptService.encrypt(securePassword.documentNumber);
      const encryptedDocumentType = this.bdbEncryptService.encrypt(securePassword.documentType);
      const encryptedPassword = this.bdbEncryptService.encrypt(securePassword.password);
      const securePasswordURL = `${environment.authenticatorEndpoint}${this.securePasswordEndpoint}`;
      const securePasswordRequestBody: RequestInfo = {
          body: {
              deviceId: this.bdbDeviceIdService.getDeviceId(),
              documentNumber: encryptedDocumentNumber,
              documentType: encryptedDocumentType,
              gRecaptchaResponse: null,
              pin: encryptedPassword,
              uuid: securePassword.uuid,
              verifyReCaptcha: encryptedDocumentNumber,
          }
      };
      return this.bdbRequestService.requestPostWithOldHeaders(securePasswordURL, securePasswordRequestBody);
  }

    async universalKeyWithSandboxV3(securePassword: SecurePassword): Promise<ResponseFromFetch> {
        const documentNumber = this.bdbSessionStorageService.get(SessionStorageKeysEnum.IDENTITY_NUMBER);
        const documentTypeFromSessionStorage = this.bdbSessionStorageService.get(SessionStorageKeysEnum.IDENTITY_TYPE);
        const documentType = documentTypeFromSessionStorage === 'C' ? 'CC' : documentTypeFromSessionStorage;
        const url = `${environment.sandboxV3Domain}/identity/v1/universal-key/validate`;
        const newHeaders = this.bdbRequestService.getStandardizedHeadersForSandboxv3(documentType, documentNumber);
        const channelMappings = {
            "FMV": "FuerzaMovil",
            "MFZ": "Microfinanzas",
          };
        let chanell = newHeaders['X-Channel']
        if (channelMappings[chanell]) {
            newHeaders['X-Channel'] = channelMappings[chanell];
        }
        const channelBodyMappings = {
            "FMV": "Fuerza Movil",
        }
        const body = this.getBody(securePassword);
        const mappedChannel = channelBodyMappings[body.dataToReport.channel];
        if (mappedChannel) {
          body.dataToReport.channel = mappedChannel;
        }
        Object.assign(newHeaders, {'content-type': 'application/json'});
        delete newHeaders['Content-Type'];
        return await this.sandbox.requestPostSandbox(url, body, newHeaders, true);
    }

    getBody(securePassword: SecurePassword): IBodyForSecureKey {
      const dataToReport = this.bdbEventsService.getInfoDataToReport();
        return {
            binData: securePassword.password,
            dataToReport
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/bdb-secure-password/services/secure-password.service.ts